import type {
  User,
  UserUI,
} from "@av/apps/common-apps/platform/services/authentication/user/current-user";
import { dayjs, type Dayjs } from "@av/config/extended-dayjs";

export interface MockUser extends User {
  /**
   * TODO: to be fetched from HR
   */
  gender: "gender.female" | "gender.male";
  hireDate: string;
}
// UI type with avatar properties
export type MockUserUI = UserUI & Omit<MockUser, "hireDate"> & { hireDate: Dayjs };

const avantiCompany = {
  id: crypto.randomUUID(),
  commonName: "Avanti",
  logoUrl: "/avanti_logo.svg",
};

export const initialUsers: MockUser[] = [
  {
    id: "5e60292d-3cdb-40d2-a9d3-182a0d7150ff",
    displayName: "Amanda Smith",
    gender: "gender.female",
    email: "amanda.harding@avanti.ca",
    hireDate: dayjs().toISOString(),
    company: avantiCompany,
  },
  {
    id: "00000000-0000-0000-0002-000000000002",
    displayName: "Demo Critus",
    gender: "gender.male",
    email: "demo.critus@avanti.ca",
    hireDate: dayjs().toISOString(),
    company: avantiCompany,
  },
  {
    id: "u1",
    displayName: "Nancy Smith",
    gender: "gender.female",
    email: "nancy.smith@avanti.ca",
    hireDate: dayjs().toISOString(),
    company: avantiCompany,
  },
  {
    id: "u2",
    displayName: "Diane Maréchal",
    gender: "gender.female",
    email: "diane.marechal@avanti.ca",
    hireDate: dayjs().subtract(2, "days").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u3",
    displayName: "Anita Chapman",
    gender: "gender.female",
    email: "anita.chapman@avanti.ca",
    hireDate: dayjs().subtract(5, "days").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u4",
    displayName: "Adam Moore",
    gender: "gender.male",
    email: "adam.moore@avanti.ca",
    hireDate: dayjs().subtract(1, "month").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u5",
    displayName: "Heraclio Nico Perea Ríos",
    gender: "gender.male",
    email: "heraclio.perea@avanti.ca",
    hireDate: dayjs().subtract(8, "days").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u6",
    displayName: "Humberto Báez Arteaga",
    gender: "gender.male",
    email: "humberto.baez@avanti.ca",
    hireDate: dayjs().subtract(12, "days").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u7",
    displayName: "Stephen Mckee",
    gender: "gender.male",
    email: "stephen.mckee@avanti.ca",
    hireDate: dayjs().subtract(15, "days").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u8",
    displayName: "Noël Massé-Lachapelle",
    gender: "gender.male",
    email: "noel.masse-lachapelle@avanti.ca",
    hireDate: dayjs().subtract(18, "days").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u9",
    displayName: "Amílcar Ribera",
    gender: "gender.male",
    email: "amilcar.ribera@avanti.ca",
    hireDate: dayjs().subtract(2, "months").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u10",
    displayName: "Dalia Márquez Cardenas",
    gender: "gender.female",
    email: "dalia.marquez@avanti.ca",
    hireDate: dayjs().subtract(3, "months").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u11",
    displayName: "Eloisa Lucio Gaytán",
    gender: "gender.female",
    email: "eloisa.lucio@avanti.ca",
    hireDate: dayjs().subtract(4, "months").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u12",
    displayName: "Jeannine-Audrey Brunet",
    gender: "gender.female",
    email: "jeannine-audrey.brunet@avanti.ca",
    hireDate: dayjs().subtract(5, "months").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u13",
    displayName: "Diane Evans",
    gender: "gender.female",
    email: "diane.evans@avanti.ca",
    hireDate: dayjs().subtract(6, "months").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u14",
    displayName: "Elizabeth Vasquez",
    gender: "gender.female",
    email: "elizabeth.vasquez@avanti.ca",
    hireDate: dayjs().subtract(7, "months").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u15",
    displayName: "Maite Morcillo-Piquer",
    gender: "gender.female",
    email: "maite.morcillo-piquer@avanti.ca",
    hireDate: dayjs().subtract(8, "months").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u16",
    displayName: "Concepción Peñalver",
    gender: "gender.female",
    email: "concepcion.penalver@avanti.ca",
    hireDate: dayjs().subtract(9, "months").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u17",
    displayName: "Maria Murphy",
    gender: "gender.female",
    email: "maria.murphy@avanti.ca",
    hireDate: dayjs().subtract(10, "months").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u18",
    displayName: "Consuelo Anaya Montalbán",
    gender: "gender.female",
    email: "consuelo.anaya@avanti.ca",
    hireDate: dayjs().subtract(11, "months").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u19",
    displayName: "Jules Proulx",
    gender: "gender.male",
    email: "jules.proulx@avanti.ca",
    hireDate: dayjs().subtract(1, "year").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u20",
    displayName: "Angelino Guadalupe Varela Sanjuan",
    gender: "gender.male",
    email: "angelino.varela@avanti.ca",
    hireDate: dayjs().subtract(1, "year").subtract(2, "months").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u21",
    displayName: "Alexandre Harvey",
    gender: "gender.male",
    email: "alexandre.harvey@avanti.ca",
    hireDate: dayjs().subtract(1, "year").subtract(4, "months").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u22",
    displayName: "Custodio Tapia Bermejo",
    gender: "gender.male",
    email: "custodio.tapia@avanti.ca",
    hireDate: dayjs().subtract(1, "year").subtract(6, "months").toISOString(),
    company: avantiCompany,
  },
  {
    id: "u23",
    displayName: "Robert Delannoy",
    gender: "gender.male",
    email: "robert.delannoy@avanti.ca",
    hireDate: dayjs().subtract(2, "years").toISOString(),
    company: avantiCompany,
  },
];
